export default "__VITE_ASSET__CqElplYD__"